import styled from "styled-components";

export const ContentHeader = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`
